import {
  SelectFormikField,
  LinkButton,
  SelectItem,
} from "@certn/cascadia-react";
import { Dialog, Modal, ModalTrigger } from "@certn/cascadia";
import { REFERENCE_RULE_OPTIONS } from "./utils";
import { useTranslation } from "react-i18next";
import { ReferenceRuleOptionsModal } from "./ReferenceRuleOptionsModal";

export type ReferenceRuleOptionSelectProps = {
  name?: string;
  isDisabled?: boolean;
  hideBPSSReference?: boolean;
};

export const ReferenceRuleOptionSelect = ({
  name = "reference_rule_options",
  isDisabled,
  hideBPSSReference = false,
}: ReferenceRuleOptionSelectProps) => {
  const { t } = useTranslation();

  return (
    <SelectFormikField
      label={t("Reference rule options")}
      name={name}
      isRequired
      testID="reference-rule-options"
      defaultValue={"DEFAULT"}
      isDisabled={isDisabled}
      info={
        <ModalTrigger
          trigger={
            <LinkButton
              textStyle="form/body-secondary-link"
              testID="role-select-whats-this"
            >
              {t("What's this?")}
            </LinkButton>
          }
        >
          <Modal testID="modal">
            <Dialog>
              {({ close }) => <ReferenceRuleOptionsModal close={close} />}
            </Dialog>
          </Modal>
        </ModalTrigger>
      }
    >
      {REFERENCE_RULE_OPTIONS.map((option) => (
        <SelectItem
          key={option.value}
          id={option.value}
          textValue={option.label}
          isDisabled={hideBPSSReference ? option.value === "BPSS" : false}
        >
          {option.label}
        </SelectItem>
      ))}
    </SelectFormikField>
  );
};
